import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ModalBasicLayout from "./ModalBasicLayout";
import ContainerModalActions from "../Containers/ContainerModalActions";
import { useTranslationApp } from "../../lib/i18next";
import { useDispatchApp } from "../../lib/redux";
import { getLinkRedirectAdle } from "../../actions/auth";
import {
  MODAL_REBRAND_ADLE_DESCRIPTION,
  MODAL_REBRAND_ADLE_GO_TO_ADLE_BUTTON,
  MODAL_REBRAND_ADLE_TITLE,
} from "../../i18n/keysTranslations";

const ModalRebrandAdle = () => {
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const location = useLocation();

  const path = `${location.pathname}${location.search}`;

  const onGoToAdle = async () => {
    const link = await dispatch(getLinkRedirectAdle({ path, params: {} }));
    window.open(link, "_blank");
  };

  return (
    <ModalBasicLayout
      modalOpen
      onCloseModal={() => {}}
      fullWidth
      maxWidth="sm"
      scroll="paper"
      hasTitle={false}
      showCloseButton={false}
      enableHistoryManagement={false}
      sx={{
        zIndex: 10000,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" align="center" sx={{ fontWeight: 600 }}>
          {t(MODAL_REBRAND_ADLE_TITLE)}
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, textAlign: "center" }}>
          {t(MODAL_REBRAND_ADLE_DESCRIPTION)}
        </Typography>
        <ContainerModalActions
          hasPadding={false}
          propsPrimaryButton={{
            showButton: true,
            text: MODAL_REBRAND_ADLE_GO_TO_ADLE_BUTTON,
            onClick: onGoToAdle,
          }}
        />
      </Box>
    </ModalBasicLayout>
  );
};

export default ModalRebrandAdle;
